<template>
  <b-row
    class="border-class tw-rounded-t-[6px] tw-w-full tw-text-[10px] tw-text-[#878787] tw-bg-[#FCFCFD] tw-font-[600] tw-tracking-[1px] tw-leading-[100%] tw-uppercase tw-px-[25px] tw-py-[23px]"
  >
    <b-col class="col-4 tw-flex tw-items-center tw-justify-start !tw-p-0"
      ><span>{{
        getComponentUiText(
          "app-component-vendor-provider-minidash-name-title-1",
        )
      }}</span>
    </b-col>
    <b-col class="col-3 tw-flex tw-items-center tw-justify-center !tw-p-0"
      ><span>{{
        getComponentUiText(
          "app-component-vendor-provider-minidash-trend-title-1",
        )
      }}</span>
    </b-col>
    <b-col class="col-2 tw-flex tw-items-center tw-justify-center !tw-p-0"
      ><span>{{
        getComponentUiText(
          "app-component-vendor-provider-minidash-score-title-1",
        )
      }}</span>
    </b-col>
    <b-col class="col-3 tw-flex tw-items-center tw-justify-center !tw-p-0"
      ><span>{{
        getComponentUiText(
          "app-component-vendor-provider-minidash-completed-title-1",
        )
      }}</span>
    </b-col>
  </b-row>
  <b-row
    v-for="(item, index) in getChecklistCompleted(props.data)"
    :key="`${item.statusAsAtDate}${item.id}`"
    :class="`tw-bg-[#FFF] ${
      index === getChecklistCompleted(props.data).length - 1
        ? 'tw-rounded-b-[6px]'
        : ''
    } ${
      isVendorDeleted(item) ? 'tw-cursor-pointer' : 'tw-cursor-not-allowed'
    } border-class tw-w-full tw-relative tw-leading-[100%] tw-px-[25px] tw-py-[20px] hover:tw-bg-[#FCFCFD]`"
    @click="openEditem(item)"
  >
    <b-col class="col-4 tw-flex tw-items-center tw-justify-start !tw-p-0"
      ><span
        :class="`tw-text-[#211F58] tw-text-[13px] tw-font-[600]  tw-line-clamp-1`"
        >{{ item.name }}
      </span>
    </b-col>
    <b-col class="col-3 tw-flex tw-items-center tw-justify-center !tw-p-0"
      ><div
        v-if="item.completed > 1"
        class="tw-absolute tw-w-[100px] tw-pl-[10px]"
      >
        <LineChart
          :height="70"
          :series="item.series"
          :chart-options="item.option"
          class-chart="tw-flex tw-items-center tw-justify-center tw-relative"
        />
      </div>
    </b-col>
    <b-col
      class="col-2 tw-flex tw-text-[13px] tw-font-[600] tw-items-center tw-justify-center !tw-p-0"
      ><span v-if="item.completed > 0" :style="`color: ${item.scoreColor}`">{{
        item.score
      }}</span>
    </b-col>
    <b-col
      class="col-3 tw-flex tw-items-center tw-justify-center !tw-p-0 tw-font-medium"
      ><span
        :class="`${
          item.completed === 0 ? 'tw-text-[#DBDBDB]' : 'tw-text-[#878787]'
        } tw-text-[13px]`"
        >{{ item.completed }}</span
      >
    </b-col>
  </b-row>
</template>

<script setup lang="ts">
import { checklistRequestedStatusId, MODAL_NAME } from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import { computed, PropType, ref } from "vue";
import { getBaseColor } from "@/utils/apexChart";
import LineChart from "../chart/lineChart.vue";
import { getMarkers } from "@/utils/apexChart";
import { cloneDeep } from "lodash";
import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import store from "@/store";

const props = defineProps({
  data: {
    type: Array as PropType<any[]>,
    default: () => [],
  },
});

const getChecklistCompleted = (items: any) => {
  return items.map((item: any) => {
    const checklistCompleteds = item.checklistRequestedHistory.filter(
      (item: any) => item.statusId === checklistRequestedStatusId.completed,
    );
    checklistCompleteds.sort((a: any, b: any) => {
      return (
        new Date(b.statusAsAtDate).getTime() -
        new Date(a.statusAsAtDate).getTime()
      );
    });
    const score =
      checklistCompleteds && checklistCompleteds.length
        ? (
            checklistCompleteds[checklistCompleteds.length - 1].scorePcnt * 100
          ).toFixed(0)
        : 0;
    const chartOption = getDataChart(checklistCompleteds.slice(-5));
    return {
      id: item.providerId,
      name: item.providerName,
      completed: checklistCompleteds.length || 0,
      checklistCompleteds,
      statusAsAtDate:
        checklistCompleteds && checklistCompleteds.length
          ? checklistCompleteds[checklistCompleteds.length - 1].statusAsAtDate
          : "",
      score: `${score}%`,
      scoreColor: getBaseColor(score, false),
      ...chartOption,
    };
  });
};

const getDataChart = (checklistCompleteds: any) => {
  const data = checklistCompleteds.map((item: any) => {
    return `${(item.scorePcnt * 100).toFixed(0)}`;
  });
  let markers = getMarkers(cloneDeep(data), cloneDeep(data), false);
  markers = markers.map((item) => {
    return {
      ...item,
      size: 0,
    };
  });
  const series = [
    {
      name: getComponentUiText(
        "app-component-vendor-provider-minidash-score-title-1",
      ),
      data: data,
    },
  ];
  const option = {
    stroke: { width: 3, curve: "straight" },
    chart: { toolbar: { show: false }, height: 70, width: 100 },
    tooltip: {
      custom: ({ dataPointIndex }) =>
        data.valueArrays?.[dataPointIndex] !== -1
          ? tooltipCustom(dataPointIndex, data, markers)
          : "",
    },
    yaxis: {
      show: false,
    },
    xaxis: {
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
      crosshairs: {
        show: false,
      },
    },

    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        type: "vertical",
        inverseColors: true,
        colorStops: [
          {
            offset: 0,
            color: "#01893D",
            opacity: 1,
          },
          {
            offset: 50,
            color: "#FFA300",
            opacity: 1,
          },
          {
            offset: 100,
            color: "#F70000",
            opacity: 1,
          },
        ],
      },
    },
    grid: {
      show: false,
      padding: { left: 10, right: 20, top: 0, bottom: 10 },
    },
  };
  return { series, option };
};
const tooltipCustom = (dataPointIndex, yAxis, markers) => {
  return `
    <div
      class="apexcharts-tooltip-series-group apexcharts-active !tw-pb-[0px] !tw-pr-[0px] !tw-normal-case"
      style="order: 1; display: flex"
    >
      <span
        class="apexcharts-tooltip-marker !tw-mr-[8px]"
        style="background-color: ${markers?.[dataPointIndex]?.strokeColor}"
      ></span>
      <div
        class="apexcharts-tooltip-text"
        style="font-family: Helvetica, Arial, sans-serif; font-size: 12px"
      >
        <div class="apexcharts-tooltip-y-group">
          <span class="apexcharts-tooltip-text-y-label" >${
            yAxis[dataPointIndex] !== null
              ? getComponentUiText(
                  "app-component-assessments-question-type-2-icon-tooltip-score-1",
                ) + ": "
              : ""
          }</span
          ><span class="apexcharts-tooltip-text-y-value !tw-ml-[0px]">${
            yAxis[dataPointIndex] === null
              ? getComponentUiText("app-share-security-chart-no-data-1")
              : `${yAxis[dataPointIndex]}%`
          }</span>
        </div>
        <div class="apexcharts-tooltip-goals-group">
          <span class="apexcharts-tooltip-text-goals-label"></span
          ><span class="apexcharts-tooltip-text-goals-value"></span>
        </div>
        <div class="apexcharts-tooltip-z-group">
          <span class="apexcharts-tooltip-text-z-label"></span
          ><span class="apexcharts-tooltip-text-z-value"></span>
        </div>
      </div>
    </div>`;
};

const listProvider = computed(() => {
  return store.state.Vendor.listProvider;
});

const isVendorDeleted = (item) => {
  const result = listProvider.value.find((e) => e.id === item.id);
  return result ? true : false;
};

const openEditem = (item: any) => {
  const result = listProvider.value.find((e) => e.id === item.id);
  if (!result) {
    return;
  }
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_MANAGE_VENDOR_DETAIL,
    properties: {
      data: {
        id: result?.id,
        name: result?.name,
        description: result?.description,
        url: result?.url,
        phone: result?.phone,
        urlSupport: result?.urlSupport,
        phoneSupport: result?.phoneSupport,
        notes: result?.notes,
      },
    },
    events: {
      "update:data": () => {},
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};
</script>

<style lang="scss" scoped>
.border-class {
  border-bottom: 1px solid var(--UI-rule, #eff0f1);
}
span {
  font-family: Poppins;
}
</style>
